import { setUser, setActiveProfile, setActiveProject, setProfiles, setConfiguration } from './actions';
import { getCurrentUserInfo, logout as logoutService } from '@/services/users';
import { getProfile, getMyProfiles } from '@/services/profiles';
import { getProject } from '@/services/projects';
import { getAllItemCategories } from '@/services/item-categories';
import { Dispatch } from 'redux';
import { CultureInfo } from '@/utils/localization';
import ClientStorage from '@/ClientStorage';
import { Profile } from '@/types';
import { getConfiguration } from '@/services/configuration';
import { loadProjectOverview } from '@/state/seller/project-overview/creator';
import { setProjectOverviewEmpty } from '@/state/seller/project-overview/actions';

export const loadConfiguration = async (dispatch: Dispatch) => {
    const configuration = await getConfiguration();

    dispatch(setConfiguration(configuration));
};

export const loadUser = async (dispatch: Dispatch) => {
    const user = await getCurrentUserInfo();
     if (user.isLoggedIn) {
        localStorage.setItem('lastLocale', user.locale);
        const profiles = await getMyProfiles();
        const activeProfile = profiles.find((x) => x.profileId === ClientStorage.lastProfileId);
        if (activeProfile) {
            await setActiveProfileId(dispatch, activeProfile.profileId);
        }
        dispatch(setProfiles(profiles));
    } else {
        dispatch(setProfiles([]));
    }
    const lsLocale = localStorage.getItem('lastLocale');
    if (!user.isLoggedIn && lsLocale) {
        user.locale = lsLocale;
    }

    dispatch(setUser(user));
};

export const logout = async (dispatch: Dispatch) => {
    dispatch({ type: 'USER_LOGOUT' });

    await logoutService();

    loadUser(dispatch);
};

export const loadActiveProfile = (dispatch, activeProfile: Profile | null) => {
    // if (activeProfile && activeProfile.type === ProfileType.Buyer) {
    //     loadBuyerDocumentTypes(dispatch);
    // }
    dispatch(setActiveProfile(activeProfile));
};

export const setActiveProfileId = async (dispatch: Dispatch, profileId: number | null) => {
    const profile = profileId ? await getProfile(profileId) : null;
    return loadActiveProfile(dispatch, profile);
};

export const setActiveProjectId = async (
    dispatch: Dispatch,
    projectId: number | null,
    disableGlobalError: boolean = false
) => {
    const project = projectId ? await getProject(projectId, disableGlobalError) : null;
    if (projectId) {
        loadProjectOverview(dispatch, projectId);
    } else {
        setProjectOverviewEmpty(dispatch);
    }

    // const documentTypes = projectId ? await getResidentialUnitDocumentTypes(projectId) : null;

    // dispatch(setSellerDocumentTypes(documentTypes));
    dispatch(setActiveProject(project));
};

export const setCurrentCulture = async (dispatch: Dispatch, newCultureInfo: CultureInfo) => {
    dispatch({
        type: 'SET_GLOBAL_CURRENT_CULTURE',
        data: newCultureInfo,
    });

    loadCatagories(dispatch, true);
};

let categoriesRequest: Promise<any> | null = null;
export const loadCatagories = async (dispatch: Dispatch, force = false) => {
    if (force || !categoriesRequest) {
        categoriesRequest = getAllItemCategories();

        dispatch({
            type: 'SET_GLOBAL_CATEGORIES',
            data: await categoriesRequest,
        });
    }
};
